import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  branchForm: {
    id: undefined,
    name: "",
    branchLink: "",
  },
  isOpenModal: false,
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    onChangeBranchForm: (state, { payload }) => {
      state.branchForm = {
        ...state.branchForm,
        name: payload.name,
        branchLink: payload.branchLink,
      };
    },
    setUpdateBranch: (state, { payload }) => {
      state.branchForm = payload;
    },
    clearBranchForm: (state) => {
      state.branchForm = initialState.branchForm;
    },
    toggleBranchModal: (state) => {
      state.isOpenModal = !state.isOpenModal;
      state.branchForm = initialState.branchForm;
    },
  },
});

export const {
  onChangeBranchForm,
  setIsEditBranch,
  setUpdateBranch,
  clearBranchForm,
  toggleBranchModal,
} = branchSlice.actions;

export default branchSlice.reducer;
